import React from "react";
import { NavLink } from "react-router-dom";

function BannerHomepage() {
  return (
    <section className="section-banner-homepage">
      <div className="banner-content-container">
        <div className="banner-left-content">
          <h1 className="banner-title">La Cachotière</h1>
          <p className="banner-tagline">
            Sur ta peau, le désir prend forme.
          </p>
          <NavLink className="btn btn-banner-decouvrir" to="/produits">
            DÉCOUVREZ NOS PRODUITS
          </NavLink>
        </div>
      </div>

    </section>
  );
}

export default BannerHomepage;
